import { useQuery } from '@tanstack/react-query';
import { apiGet, qk } from './_client';

/** GET /api/workspaces/{id}/films — films in a workspace (with scene/shot counts). */
export function useWorkspaceFilms(workspaceId, options = {}) {
  const { enabled, ...rest } = options;
  return useQuery({
    queryKey: qk.workspaceFilms(workspaceId),
    queryFn: ({ signal }) => apiGet(`/workspaces/${workspaceId}/films`, signal),
    enabled: !!workspaceId && (enabled ?? true),
    ...rest,
  });
}
